import React from 'react';
import PropTypes from 'prop-types';

import { Box, IconButton, Typography } from '@mui/material';

import { ChevronRightOutlined } from '@mui/icons-material';

import { diagnosisDialogStyles } from './diagnosisStyles';

const DiagnosisList = ({ diagnoses, selectedDiagnosisIds, onSelect }) => {
  if (!diagnoses.length) {
    return (
      <Box sx={diagnosisDialogStyles.emptyState}>
        <Typography sx={diagnosisDialogStyles.emptyText}>
          No diagnoses found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={diagnosisDialogStyles.listWrapper}>
      {diagnoses.map(diagnosis => {
        const selected = selectedDiagnosisIds.includes(diagnosis.id);

        const handleSelect = () => {
          if (!selected) {
            onSelect(diagnosis);
          }
        };

        return (
          <Box
            key={diagnosis.id}
            onClick={handleSelect}
            sx={[
              diagnosisDialogStyles.diagnosisRow,
              selected && diagnosisDialogStyles.selectedDiagnosisRow,
              {
                cursor: selected ? 'default' : 'pointer'
              }
            ]}>
            <IconButton
              size="small"
              disabled={selected}
              onClick={e => {
                e.stopPropagation(); // Prevent row click from firing again
                handleSelect();
              }}
              sx={diagnosisDialogStyles.moveButton}>
              <ChevronRightOutlined sx={diagnosisDialogStyles.moveIcon} />
            </IconButton>

            <Typography
              title={`${diagnosis.code} ${diagnosis.description}`}
              sx={diagnosisDialogStyles.diagnosisText}>
              {diagnosis.code} {diagnosis.description}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

DiagnosisList.propTypes = {
  diagnoses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ),
  selectedDiagnosisIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  onSelect: PropTypes.func
};

DiagnosisList.defaultProps = {
  diagnoses: [],
  selectedDiagnosisIds: [],
  onSelect: () => {}
};

export default DiagnosisList;
